import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { MenuItem } from '@fluentui/react-components';
import { IconName } from '../constants';
import { getCampaignMenuItemStyles } from '../styles';

export const CampaignSelectorItem = ({
  name, severity, onClick, className,
}) => {
  const classes = useDefaultStyles(getCampaignMenuItemStyles);
  const statusIcon = (
    <div className={classnames('campaign-selector-item-icon', classes.CampaignItemIcon)}>
      {severity
        ? (
          <Glyphicon
            className={classnames(
              'campaign-selector-item-glyphicon',
              classes.SeverityIcon,
              classes[`CampaignSelectorItemGlyphicon-${severity}`]
            )}
            glyph={`ba-${IconName[severity]}`}
          />)
        : null}
    </div>
  );

  return (
    <MenuItem
      className={classnames('campaign-selector-item', classes.CampaignMenuItem, className)}
      aria-label={name}
      onClick={onClick}
      icon={statusIcon}
    >
      <span className="campaign-selector-item-name">{name}</span>
    </MenuItem>
  );
};

CampaignSelectorItem.propTypes = {
  name: PropTypes.string.isRequired,
  severity: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

CampaignSelectorItem.defaultProps = {
  severity: null,
  className: '',
};
